/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Auto_Correct_Timing_ModalInputs */

const en_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Auto Correct Timing Modal`)
};

const fr_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre de correction automatique`)
};

const de_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Timingkorrektur schließen`)
};

const it_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la finestra modale di correzione automatica dei tempi`)
};

const ru_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно автокоррекции времени`)
};

const es_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el modo de sincronización de corrección automática`)
};

const zh_cn2_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭自动校正计时模式`)
};

const ja_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動修正タイミングモーダルを閉じる`)
};

const hi_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो करेक्ट टाइमिंग मॉडल बंद करें`)
};

const pt_pt2_close_auto_correct_timing_modal = /** @type {(inputs: Close_Auto_Correct_Timing_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar Modal de Correção Automática de Tempo`)
};

/**
* | output |
* | --- |
* | "Close Auto Correct Timing Modal" |
*
* @param {Close_Auto_Correct_Timing_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_auto_correct_timing_modal = /** @type {((inputs?: Close_Auto_Correct_Timing_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Auto_Correct_Timing_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_auto_correct_timing_modal(inputs)
	if (locale === "de") return de_close_auto_correct_timing_modal(inputs)
	if (locale === "it") return it_close_auto_correct_timing_modal(inputs)
	if (locale === "ru") return ru_close_auto_correct_timing_modal(inputs)
	if (locale === "es") return es_close_auto_correct_timing_modal(inputs)
	if (locale === "zh-CN") return zh_cn2_close_auto_correct_timing_modal(inputs)
	if (locale === "ja") return ja_close_auto_correct_timing_modal(inputs)
	if (locale === "hi") return hi_close_auto_correct_timing_modal(inputs)
	if (locale === "pt-PT") return pt_pt2_close_auto_correct_timing_modal(inputs)
	return en_close_auto_correct_timing_modal(inputs)
});